import apiClient from './api'

export default {
    async login (params) {
        return await apiClient.post('/auth/login', params)
    }
}